import React from 'react';
import Chip from '@material-ui/core/Chip';

const getStyle = (status) => {
  switch (status) {
    case 'AguardandoAutorizacao':
      return {
        backgroundColor: '#FFD700',
      };
    case 'SolicitandoAutorizacao':
      return {
        backgroundColor: '#FFD700',
      };
    case 'AutorizacaoSolicitada':
      return {
        backgroundColor: '#FFD700',
      };
    case 'EmProcessoDeAutorizacao':
      return {
        backgroundColor: '#FFD700',
      };
    case 'AutorizadaAguardandoGeracaoPDF':
      return {
        backgroundColor: '#FFD700',
      };
    case 'Autorizada':
      return {
        backgroundColor: '#32CD32',
      };
    case 'Negada':
      return {
        backgroundColor: '#FF0000',
      };
    default:
      return {
        backgroundColor: '#FFFAF0',
      };
  }
};

function components(props) {
  const { status } = props;
  return <Chip label={status} color="primary" style={getStyle(status)} />;
}

export default components;
